<template>
  <div class="container">
    <BreadcrumbGroup v-if="!isAuWallet()" :items="breadcrumbItems" />

    <HeadingOne class="-margin-md"
      >au PAY 残高にチャージ（お借り入れ）</HeadingOne
    >

    <ErrorsAlert :errors="errors"></ErrorsAlert>

    <WizardGroup class="-margin-md">
      <MainWizard :active-index="0" type="mb"></MainWizard>
    </WizardGroup>

    <p class="_mb-0">au PAY 残高にチャージいたします。</p>
    <p>
      お客さまのau PAY 残高については<a
        href="https://wallet.auone.jp/index.html"
        class="BtnText textlink"
        target="_blank"
        >au PAY サイト</a
      >にてご確認ください。
    </p>

    <p>＜ご注意＞</p>
    <p>
      <router-link
        v-scroll-to="{ el: '#attention', offset: -150 }"
        :to="{ path: '#' }"
        class="textlink"
        >以下に該当する場合</router-link
      >は、au PAY
      残高にチャージができませんので、他のお借り入れ方法にてご利用ください。
    </p>
    <form novalidate @submit.prevent="submitValidateDepositIntoPrepaid">
      <TableBox class="_mb-md-30 _mb-sm-20 _mt-30">
        <TableBody>
          <TableRow>
            <TableHeader class="-requires"> チャージ予定日 </TableHeader>
            <TableData class="-pctextright">
              お手続き完了後、すぐにご利用いただけます。
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader class="-requires"> ご利用可能額 </TableHeader>
            <TableData class="-pctextright">
              {{ numberToCurrency(depositIntoPrepaid.available_credit) }}
            </TableData>
          </TableRow>
        </TableBody>
      </TableBox>
      <AmountBox
        v-model="userData.amount"
        class="_mb-md-60 _mb-sm-25"
      ></AmountBox>

      <small
        >※以下の場合はご利用いただけませんので、他のお借り入れ方法にてご利用ください。</small
      >

      <ListGroup id="attention" class="-normal _mt-10">
        <ListItem class="-normal"
          >au PAY
          プリペイドカードをお持ちでないまたは、ご登録名義が異なる場合</ListItem
        >
        <ListItem class="-normal"
          >au PAY 残高のチャージ上限額を超える場合</ListItem
        >
        <ListItem class="-normal">システムメンテナンス時間帯など</ListItem>
      </ListGroup>

      <template v-if="!isAuWallet()">
        <HeadingFour class="_mt-20 _mb-10">その他のお借り入れ方法</HeadingFour>
        <BtnText router-name="mb011" class="-next -ib _mb-md-10 _mb-sm-15"
          >ご登録口座へのお振込み</BtnText
        ><br />
        <BtnText router-name="sv025" target="_blank" class="-next -ib"
          >セブン銀行スマホＡＴＭ</BtnText
        >
      </template>

      <BtngroupDouble class="-margin-lg">
        <template #main>
          <BtnMain
            class="-main"
            @click.prevent="submitValidateDepositIntoPrepaid"
            >確認画面へ</BtnMain
          >
        </template>
        <template #back>
          <BtnBack v-if="!isAuWallet()" class="-back -sm" router-name="mb001"
            >戻る</BtnBack
          >
        </template>
      </BtngroupDouble>
    </form>
  </div>
  <!-- container -->
</template>

<script>
import { initCredentials } from "@/utils/Auth";
import {
  getUserDataForMemberLambdaInvoke,
  depositIntoPrepaidLambdaInvoke,
  validateDepositIntoPrepaidLambdaInvoke,
} from "@/utils/LambdaHelper";
import { setMeta } from "@/utils/Meta";
import { numberToCurrency } from "@/utils/Filter";
import { goToErrorPage, scrollTop } from "@/utils/Other";

import { isAuWallet } from "@/utils/UserAgent";
import HeadingOne from "@/components/heading/HeadingOne";
import ErrorsAlert from "@/components/alert/ErrorsAlert";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import AmountBox from "@/components/box/AmountBox";
import BtngroupDouble from "@/components/button/BtngroupDouble";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
import HeadingFour from "@/components/heading/HeadingFour";
import BtnText from "@/components/button/BtnText";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Mb012",
  components: {
    ListItem,
    ListGroup,
    BtnText,
    HeadingFour,
    BtnBack,
    BtnMain,
    BtngroupDouble,
    AmountBox,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    MainWizard,
    WizardGroup,
    ErrorsAlert,
    HeadingOne,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "au PAY 残高にチャージ（お借り入れ）｜お借り入れ",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト",
    });

    return {
      numberToCurrency,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "au PAY 残高にチャージ（お借り入れ）",
          active: true,
        },
      ],
      errors: {},
      isDisabled: false,
      inputAmount: "",
      depositIntoPrepaid: {
        available_credit: "",
      },
      userData: {
        amount: "",
      },
    };
  },
  mounted() {
    try {
      getUserDataForMemberLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
      depositIntoPrepaidLambdaInvoke()
        .then((res) => {
          let resBody = JSON.parse(res.body);
          for (let key in resBody) {
            if (
              Object.prototype.hasOwnProperty.call(this.depositIntoPrepaid, key)
            ) {
              this.depositIntoPrepaid[key] = resBody[key];
            }
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    submitValidateDepositIntoPrepaid: function () {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        initCredentials()
          .then(() => {
            validateDepositIntoPrepaidLambdaInvoke(this.userData)
              .then((res) => {
                if (Object.prototype.hasOwnProperty.call(res, "body")) {
                  let resBody = JSON.parse(res.body);
                  this.errors = res.errors || {};
                  if (
                    resBody.event.inputs.prepaid_result === "5002" ||
                    resBody.event.inputs.prepaid_result === "5004"
                  ) {
                    this.errors = { prepaid_result: ["glt_no_prepaid"] };
                    scrollTop();
                    this.isDisabled = false;
                  } else if (Object.keys(this.errors).length > 0) {
                    scrollTop();
                    this.isDisabled = false;
                  } else if (resBody.event.inputs.prepaid_result !== "0000") {
                    this.errors = { prepaid_result: ["glt_invalid"] };
                    scrollTop();
                    this.isDisabled = false;
                  } else {
                    this.$router.push({ name: "mb014" });
                  }
                } else {
                  this.$router.push({ name: "SessionTimeOut" });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    isAuWallet: function () {
      return isAuWallet();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.btn-text {
  &:hover {
    text-decoration: underline;
    color: $orange;
  }
}
</style>
